// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"21":"7efc21ac7644167f","524":"ffc3002f25b6669a","876":"f35582acd0b5e4cb"}[chunkId] + ".js";
};